<template>
  <button
    class="flex items-center gap-x-2 whitespace-nowrap text-sm font-bold uppercase tracking-widest text-blue md:ml-auto"
    @click="toggleFilters"
  >
    <UiIcon icon="filter" />

    <span class="hidden md:inline">
      {{ $t(isFiltersOpen ? 'hide_filters' : 'show_filters') }}
    </span>

    <span class="md:hidden">
      {{ $t('filters') }}
    </span>
  </button>
</template>

<script setup lang="ts">
interface Props {
  isFiltersOpen?: boolean;
}
interface Emits {
  (e: 'toggle-filters'): void;
}

withDefaults(defineProps<Props>(), {
  isFiltersOpen: false,
});
const emit = defineEmits<Emits>();

const toggleFilters = () => {
  emit('toggle-filters');
};
</script>
